import axios from 'axios';

export default axios.create({
  // baseURL: 'https://shnitzer-paykey.herokuapp.com',
  baseURL: process.env.BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Expose-Headers': 'X-Auth'
  },
});
